import { render } from "./GuardadoSatisfactorioAdvertenciaView.vue?vue&type=template&id=1d00cd4e"
import script from "./GuardadoSatisfactorioAdvertenciaView.vue?vue&type=script&lang=js"
export * from "./GuardadoSatisfactorioAdvertenciaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__